import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { FormControl } from 'react-bootstrap'

import GlgTooltipIcon from './glg_tooltip_icon'

class GlgCheckbox extends Component {
  constructor(props) {
    super(props)
    this.toggleChecked = this.toggleChecked.bind(this)

    let initialChecked = props.defaultChecked
    if (_.isUndefined(initialChecked)) {
      initialChecked = props.checked
    }
    if (_.isUndefined(initialChecked)) {
      initialChecked = false
    }
    this.state = {
      checked: initialChecked,
    }
  }

  // In case it's used as a controlled component and the value changes
  componentDidUpdate(prevProps) {
    if (prevProps.checked !== this.props.checked) {
      this.setState({
        checked: this.props.checked,
      })
    }
  }

  toggleChecked(e) {
    if (!this.props.disabled) {
      const newValue = !this.state.checked
      this.setState({
        checked: newValue,
      })
      if (this.props.onChange) {
        const checkboxValue = e.target.value ? e.target.value : this.props.value
        this.props.onChange(newValue, checkboxValue, e)
      }
    }
  }

  getInlineClass() {
    return this.props.inline ? 'checkbox-inline' : ''
  }

  render() {
    return (
      <div className={ `glg-checkbox checkbox btsp_checkbox checkbox-primary ${ this.getInlineClass() }` }
           onClick={ this.toggleChecked }
      >
        <FormControl
          type="checkbox"
          name={ this.props.name }
          checked={ this.state.checked }
          value={ this.props.value }
          disabled={ this.props.disabled }
          onChange={ () => {} }
          className={this.props.checkboxClass} />
        <label className={this.props.checked || this.props.defaultChecked ? 'checked' : ''}>
          <span className='clickable'>
            { this.props.label }
            {this.props.tooltip && (
              <GlgTooltipIcon tooltip={ this.props.tooltip } />
            )}
          </span>
        </label>
      </div>
    )
  }
}

GlgCheckbox.propTypes = {
  // The input name
  name: PropTypes.string.isRequired,
  // The controlled value
  checked: PropTypes.bool,
  // The initial value
  defaultChecked: PropTypes.bool,
  // If disabled is true the checkbox is disabled
  disabled: PropTypes.bool,
  // The checkbox value
  value: PropTypes.string,
  // Text on the right of the checkbox
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  // Callback for when the value changes
  onChange: PropTypes.func,
  // If tooltip is passed there will be an icon with this text
  tooltip: PropTypes.string,
  // Whether the radio to be on the same line as surrounding elements
  inline: PropTypes.bool,
  // Extra classes for the checkbox
  checkboxClass: PropTypes.string,
}

export default GlgCheckbox
